import React, { useCallback, useEffect, useState } from 'react';

import { formatActivityDateTime } from './userActivityFormat';

import TextButton from 'CommonComponents/TextButton';

/**
 * One user's logins on this project, 50 at a time, newest first.
 */
export default function UserLoginHistory({ historyUrl, total }) {
    const [logins, setLogins] = useState([]);
    const [page, setPage] = useState(0);
    const [lastPage, setLastPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const load = useCallback(
        (nextPage) => {
            setLoading(true);
            setError(null);

            axios
                .get(historyUrl, { params: { page: nextPage } })
                .then(({ data }) => {
                    setLogins((previous) => (nextPage === 1 ? data.data : [...previous, ...data.data]));
                    setPage(data.meta.current_page);
                    setLastPage(data.meta.last_page);
                })
                .catch(() => setError($t('Something went wrong')))
                .finally(() => setLoading(false));
        },
        [historyUrl],
    );

    useEffect(() => {
        load(1);
    }, [load]);

    return (
        <div className="tw-px-4 tw-py-3">
            <div className="tw-text-xs tw-font-semibold tw-text-charcoal tw-mb-2">{$t('Login history ({{count}})', { count: total })}</div>

            {error && <div className="tw-text-xs tw-text-red">{error}</div>}

            {/* Newest first, reading down each column. */}
            <ul className="tw-columns-1 sm:tw-columns-2 lg:tw-columns-3 tw-gap-x-6 tw-list-none tw-ps-0 tw-mb-0">
                {logins.map((login) => (
                    <li key={login.id} className="tw-text-xs tw-text-charcoal-75 tw-py-0.5">
                        {formatActivityDateTime(login.logged_in_at)}
                    </li>
                ))}
            </ul>

            {loading && <div className="tw-text-xs tw-text-charcoal-50 tw-mt-2">{$t('Loading')}…</div>}

            {!loading && page < lastPage && (
                <TextButton variant="primary" className="tw-mt-2" onClick={() => load(page + 1)}>
                    {$t('Show more')}
                </TextButton>
            )}
        </div>
    );
}
